
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_o7edo_97",
  "tools": "awsui_tools_wih1l_o7edo_108",
  "tools-filtering": "awsui_tools-filtering_wih1l_o7edo_114",
  "tools-align-right": "awsui_tools-align-right_wih1l_o7edo_128",
  "tools-pagination": "awsui_tools-pagination_wih1l_o7edo_132",
  "tools-preferences": "awsui_tools-preferences_wih1l_o7edo_132",
  "tools-small": "awsui_tools-small_wih1l_o7edo_138",
  "table": "awsui_table_wih1l_o7edo_144",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_o7edo_150",
  "wrapper": "awsui_wrapper_wih1l_o7edo_154",
  "variant-stacked": "awsui_variant-stacked_wih1l_o7edo_162",
  "variant-container": "awsui_variant-container_wih1l_o7edo_162",
  "variant-embedded": "awsui_variant-embedded_wih1l_o7edo_166",
  "has-header": "awsui_has-header_wih1l_o7edo_169",
  "has-footer": "awsui_has-footer_wih1l_o7edo_172",
  "cell-merged": "awsui_cell-merged_wih1l_o7edo_186",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_o7edo_197",
  "empty": "awsui_empty_wih1l_o7edo_212",
  "loading": "awsui_loading_wih1l_o7edo_216",
  "selection-control": "awsui_selection-control_wih1l_o7edo_225",
  "selection-control-header": "awsui_selection-control-header_wih1l_o7edo_232",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_o7edo_237",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_o7edo_247",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_o7edo_250",
  "dark-header": "awsui_dark-header_wih1l_o7edo_258",
  "header-secondary": "awsui_header-secondary_wih1l_o7edo_262",
  "table-has-header": "awsui_table-has-header_wih1l_o7edo_278",
  "header-controls": "awsui_header-controls_wih1l_o7edo_282",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_o7edo_296",
  "footer": "awsui_footer_wih1l_o7edo_296",
  "thead-active": "awsui_thead-active_wih1l_o7edo_305",
  "row": "awsui_row_wih1l_o7edo_306",
  "row-selected": "awsui_row-selected_wih1l_o7edo_307"
};
  